(() => {
  'use strict';
  const root = document.body.dataset.root.replace(/\/?$/, '/');
  const drawer = document.querySelector('#CartDrawer');
  const zoom = document.querySelector('#ImageZoom');
  let busy = false;
  let cartTrigger;
  const status = text => { document.querySelector('#LiveStatus').textContent = text; };
  function showError(form, message) {
    const target = form?.querySelector('.form-error');
    if (target) { target.textContent = message; target.hidden = false; }
    status(message);
  }
  async function request(path, options) {
    const response = await fetch(root + path, {credentials: 'same-origin', ...options});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Please check the selected quantity and try again.');
    return data;
  }
  async function refreshCart() {
    const response = await fetch(root + '?section_id=cart-content', {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok) throw new Error('Could not refresh the cart.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const content = doc.querySelector('[data-cart-content]');
    if (!content) throw new Error('Could not refresh the cart.');
    document.querySelector('#CartContents').replaceChildren(content);
    document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent = content.dataset.count;});
  }
  function openCart(trigger) {
    if (!drawer.open) { cartTrigger = trigger || document.activeElement; drawer.showModal(); }
  }
  drawer?.addEventListener('close', () => { if (cartTrigger?.isConnected) cartTrigger.focus(); });
  document.addEventListener('click', async event => {
    const close = event.target.closest('[data-close]');
    if (close) {close.closest('dialog').close(); return;}
    const opener = event.target.closest('[data-open-cart]');
    if (opener && drawer?.showModal && !event.ctrlKey && !event.metaKey) {
      event.preventDefault();
      if (busy) return;
      busy = true; opener.setAttribute('aria-busy', 'true');
      try {await refreshCart(); openCart(opener);} catch {window.location.assign(opener.href);}
      finally {busy = false; opener.removeAttribute('aria-busy');}
    }
    const photo = event.target.closest('[data-zoom]');
    if (photo && zoom?.showModal && !event.ctrlKey && !event.metaKey) {
      event.preventDefault();
      const image = zoom.querySelector('img'); image.src = photo.href; image.alt = photo.querySelector('img')?.alt || 'Plant photograph'; zoom.showModal();
    }
    if (event.target.closest('[data-sticky-add]')) document.querySelector('[data-product-form]')?.requestSubmit();
    const remove = event.target.closest('[data-remove-key]');
    if (remove && remove.closest('#CartDrawer')) {event.preventDefault(); await changeQuantity(remove.dataset.removeKey, 0, remove.closest('form'));}
    const productLink = event.target.closest('.card a[href]');
    if (productLink) {try {sessionStorage.setItem('scfp-return', JSON.stringify({url: location.href, scroll: window.scrollY}));} catch {}}
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-add-form]');
    if (!form || !drawer?.showModal) return;
    event.preventDefault();
    if (busy) return;
    const button = form.querySelector('[type="submit"]');
    const original = button.textContent;
    busy = true; button.disabled = true; button.textContent = 'Adding…';
    form.querySelector('.form-error').hidden = true;
    let added = false;
    try {
      const body = new FormData(form);
      const note = body.get('properties[Special requests]');
      if (typeof note === 'string') {
        if (note.trim()) body.set('properties[Special requests]', note.trim());
        else body.delete('properties[Special requests]');
      }
      const quantity = Number(body.get('quantity') || 1);
      if (!Number.isInteger(quantity) || quantity < 1) throw new Error('Enter a whole-number quantity of at least one.');
      if (form.hasAttribute('data-exact') || form.dataset.photoType === 'exact') {
        const cart = await request('cart.js');
        if (quantity > 1 || cart.items.some(item => String(item.variant_id) === String(body.get('id')) && item.quantity >= 1)) throw new Error('This pictured plant is already in your cart.');
      }
      await request('cart/add.js', {method: 'POST', body});
      added = true;
      await refreshCart();
      openCart(button); status('Added to your cart.');
    } catch (error) {
      if (added) {
        showError(form, 'Added to your cart, but the drawer could not refresh. Open the cart to review it before adding again.');
      } else showError(form, error.message || 'Could not confirm the addition. Check your cart before trying again.');
    } finally {busy = false; button.disabled = false; button.textContent = original;}
  });
  async function changeQuantity(key, quantity, form) {
    if (busy) return;
    if (!Number.isInteger(quantity) || quantity < 0) {showError(form, 'Enter a whole-number quantity of zero or more.'); return;}
    busy = true;
    form.querySelectorAll('button,input').forEach(el => {el.disabled = true;});
    try {
      await request('cart/change.js', {method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({id:key, quantity})});
      await refreshCart(); status('Cart updated.');
      drawer.querySelector('input[name="updates[]"]')?.focus();
    } catch (error) {showError(form, error.message || 'Could not update the cart. Please refresh to review it.');}
    finally {busy = false; form.querySelectorAll('button,input').forEach(el => {el.disabled = false;});}
  }
  document.addEventListener('change', event => {
    const input = event.target;
    if (input.matches('[data-line-key]') && input.closest('#CartDrawer')) {
      if (input.reportValidity()) changeQuantity(input.dataset.lineKey, Number(input.value), input.closest('form'));
    }
    if (input.matches('[data-variant-select]')) {
      const option = input.options[input.selectedIndex];
      document.querySelector('[data-product-price]').textContent = option.dataset.price;
      const available = option.dataset.available === 'true';
      document.querySelectorAll('.product-add, [data-sticky-add]').forEach(button => {button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out';});
      const url = new URL(location.href);url.searchParams.set('variant', option.value);history.replaceState({}, '', url);
    }
  });
  const mainAdd = document.querySelector('.product-add');
  if (mainAdd && 'IntersectionObserver' in window) new IntersectionObserver(([entry]) => {
    document.querySelector('.sticky-buy')?.classList.toggle('visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
  }).observe(mainAdd);
  try {
    const previous = JSON.parse(sessionStorage.getItem('scfp-return') || 'null');
    if (previous) {
      const url = new URL(previous.url);
      if (url.origin === location.origin && (url.pathname === root || url.pathname.startsWith(root + 'collections/') || url.pathname === root + 'search')) {
        const back = document.querySelector('[data-back-shop]'); if (back) back.href = previous.url;
        if (previous.url === location.href && document.querySelector('.grid')) requestAnimationFrame(() => window.scrollTo(0, Number(previous.scroll) || 0));
      }
    }
  } catch {}
  window.addEventListener('pageshow', () => { if (document.querySelector('[data-cart-count]')) request('cart.js').then(cart => document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent=cart.item_count;})).catch(() => {}); });
})();
